import React from 'react'
import { Card } from 'plume-ui'
import { css } from '@emotion/react'

type Props = {
  children?: string
  dataTestId?: string
}

export const EmptyCard: React.FC<Props> = (props) => {
  const text = props.children ?? '表示するデータがありません'

  return (
    <Card>
      <Card.Content>
        <div
          className="empty"
          css={css`
            display: flex;
            align-items: center;
            justify-content: center;
            color: #999;
            font-size: 14px;
            padding: 5px;
          `}
          data-test-id={props.dataTestId}
        >
          {text}
        </div>
      </Card.Content>
    </Card>
  )
}
